export default __webpack_public_path__ + "static/media/laughing.34d8267f.png";